import { Alert } from '@agentnet/components';
import { Typography } from '@material-ui/core';
import { Party } from 'api/file/interfaces/get-file-order-insights';
import clsx from 'clsx';
import { pdfProductEnableMessage } from 'features/help/constants';
import { useMemo } from 'react';
import EnabledPdfProducts from './EnabledPdfProduct';
import OrderInsightsRiskIcon from './OrderInsightsRiskIcon';
import useStyles from './PdfListStyles';

interface IPdfValidation {
  title: string;
  type?: 'ContactValidation' | 'EnhancedIdentityVerification';
  party: Party;
  hasRisks: boolean;
  isEnabled?: boolean;
}

const PdfValidation = ({ party, title, type = 'ContactValidation', hasRisks, isEnabled }: IPdfValidation) => {
  const classes = useStyles();

  const riskIcon = useMemo(() => {
    if (!isEnabled) {
      return 'None';
    }
    if (type === 'EnhancedIdentityVerification' && !party.phoneNumber) return 'Error';

    if (party.phoneNumber || party.emailAddress) {
      if (
        type === 'EnhancedIdentityVerification' &&
        party.enhancedIdentifyVerification?.transactionStatus === 'Pending'
      )
        return 'Pending';

      if (type === 'EnhancedIdentityVerification' && party.enhancedIdentifyVerification?.transactionStatus === 'Failed')
        return 'Error';

      if (
        (type === 'ContactValidation' && party?.contactValidation) ||
        (type === 'EnhancedIdentityVerification' && party?.enhancedIdentifyVerification)
      )
        return hasRisks ? 'Alert' : 'Success';
    }

    return 'None';
  }, [hasRisks, party, isEnabled]);

  return (
    <div className={classes.brdBtm}>
      <div className={clsx(classes.flex, classes.paddingLeftZero, classes.typographyFontSize)}>
        <div className={classes.labelCol}>
          <span className={classes.flexCenter}>
            <OrderInsightsRiskIcon riskSeverity={riskIcon} isPdf />
            <Typography
              variant="h4"
              color="textSecondary"
              className={clsx(classes.marginLeft, classes.typographyFontSize, classes.bold)}
            >
              {title}:
            </Typography>
          </span>
        </div>
        <div className={classes.flexGrow}>
          {isEnabled ? (
            <EnabledPdfProducts type={type} party={party} />
          ) : (
            <Alert
              className={clsx(classes.infoAlert, classes.typographyFontSize)}
              severity={'info'}
              icon={<OrderInsightsRiskIcon riskSeverity={'None'} isPdf />}
            >
              {pdfProductEnableMessage}
            </Alert>
          )}
        </div>
      </div>
    </div>
  );
};

export default PdfValidation;
